<template>
  <div v-if="type !== 0 && type !== 8"
    class="buttons__wrapper"
  >
    <div v-if="1 <= type && type <= 4"
      class="button__static"
      :style="`transform: translateX(${xChild - 3}px) translateY(${yChild - 3}px) translateZ(0)translate3d(0, 0, 0);`"
      :class="{
        'button__small': type === 1 || type === 3,
        'button__large': type === 2 || type === 4,
        'button__red'  : type === 1 || type === 2,
        'button__black': type === 3 || type === 4,
        'button__hidden': hidden
      }"
    ></div>  <!-- static button -->
    <div v-if="type === 5 || type === 6 || type === 7"
      class="button__animator"
      :style="`transform: translateX(${xChild - 3}px) translateY(${yChild - 3}px) translateZ(0)translate3d(0, 0, 0);`"
    >   <!-- animation button -->
      <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 200 200">
        <circle cx="100" cy="100" r="80"
          :style="`stroke-dasharray: ${strokeLength}px,10000px`"></circle>
      </svg>
    </div>
  </div>
  <div v-else-if="type === 0" class="buttons__wrapper pen">
    <div
      class="button__static"
      :style="`transform: translateX(${xChild - 3}px) translateY(${yChild - 3}px) translateZ(0)translate3d(0, 0, 0);`"
    >
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40"><title>Asset 1</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="cls-1" d="M35,39.6l4.2-4.2L21.4,14.6l-7.1,7.1ZM13.3,20.8l7-7L11.1,7.4,7,11.5ZM2.1,6.5l5,3.9,2.9-3L6.5,2.9S2.3,2.7,0,0C0,0,2.4,3.2,2.1,6.5ZM3.5,5.1a.9.9,0,0,1,1.8,0v.1a.88.88,0,0,1-.9.8A1.06,1.06,0,0,1,3.5,5.1ZM40,36.1,36.1,40A3.74,3.74,0,0,0,40,36.1Z"/></g></g></svg>
    </div>
  </div>
  <div v-else class="buttons__wrapper pen">
    <div
      class="button__static"
      :style="`transform: translateX(${xChild - 3}px) translateY(${yChild - 3}px) translateZ(0)translate3d(0, 0, 0);`"
    >
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="20" height="20" x="0px" y="0px"
        viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
      <g>
        <g>
          <path d="M330.667,490.667c-35.292,0-64-28.708-64-64v-160H288c5.896,0,10.667-4.771,10.667-10.667s-4.771-10.667-10.667-10.667
            h-21.333v-160c0-35.292,28.708-64,64-64c5.896,0,10.667-4.771,10.667-10.667C341.333,4.771,336.562,0,330.667,0
            C298.583,0,270.562,17.802,256,44.052C241.437,17.802,213.417,0,181.333,0c-5.896,0-10.667,4.771-10.667,10.667
            c0,5.896,4.771,10.667,10.667,10.667c35.292,0,64,28.708,64,64v160H224c-5.896,0-10.667,4.771-10.667,10.667
            s4.771,10.667,10.667,10.667h21.333v160c0,35.292-28.708,64-64,64c-5.896,0-10.667,4.771-10.667,10.667
            c0,5.896,4.771,10.667,10.667,10.667c32.083,0,60.104-17.802,74.667-44.052C270.562,494.198,298.583,512,330.667,512
            c5.896,0,10.667-4.771,10.667-10.667C341.333,495.438,336.562,490.667,330.667,490.667z"/>
        </g>
      </g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g><g></g></svg>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'VCursor',
  data () {
    return {
      xChild: 0,
      yChild: 0,
      emitDoneCycle: false,
      isOnSignatureCursor: false,
      zoomIn: false,
      colorIn: false,
      cursorTimer: null,
      strokeLength: 0
    }
  },
  computed: {
    ...mapState({
      type: state => state.cursor.type,
      hidden: state => state.cursor.hidden
    })
  },
  watch: {
    type (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (this.cursorTimer) {
          clearInterval(this.cursorTimer)
          this.cursorTimer = null
        }
        if (newValue === 5) {
          this.cursorTimer = setInterval(() => {
            this.strokeLength += (2 * 3.14 * 80) / (6000 / 100)
            if (this.strokeLength >= 2 * 3.14 * 80) {
              this.strokeLength = 0
            }
          }, 100)
        } else if (newValue === 6) {
          this.cursorTimer = setInterval(() => {
            this.strokeLength += (2 * 3.14 * 80) / (7000 / 100)
            if (this.strokeLength >= 2 * 3.14 * 80) {
              this.strokeLength = 0
            }
          }, 100)
        } else if (newValue === 7) {
          this.cursorTimer = setInterval(() => {
            this.strokeLength += (2 * 3.14 * 80) / (3000 / 100)
            if (this.strokeLength >= 2 * 3.14 * 80) {
              this.strokeLength = 0
            }
          }, 100)
        }
      }
    }
  },
  mounted () {
    // On desktop and laptop change the mouse cursor
    if (document.documentElement.clientWidth >= 900) {
      let moveCursor = e => {
        this.xChild = e.clientX
        this.yChild = e.clientY
      }
      window.addEventListener('mousemove', moveCursor)

      document.dispatchEvent(new Event('mousemove'))
    }
  }
}
</script>
